export class Graph {
    constructor(graphType, source) {
        this.graphType = graphType;
        this.source = source;
    }
}
